import { format } from "date-fns"
import { useEffect, useState } from "react"
import { useParams } from "../common/useParams"
import { useGetData } from "../getData/useGetData"
import { ClimateDataType } from "../../types/climateData/ClimateDataTypes"

const useGetOUWeather = () => {
    const { getData } = useGetData()
    const { useUrlParamiters } = useParams()
    const { orgUnit } = useUrlParamiters()
    const [data, setData] = useState<ClimateDataType>()
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        const fetchData = async () => {
            const today = format(new Date(), "yyyyMMdd");

            setLoading(true)

            try {
                const resp = await getData(
                    `climateData/future?periodType=DAILY_RANGE&startDate=${today}&endDate=${today}&organisationUnitId=${orgUnit}`
                );
                setData(resp?.climateData[0]);
            }
            catch (error) {
                console.error("Error fetching data:", error);
            }
            finally {
                setLoading(false)
            }
        };

        void fetchData();
    }, [orgUnit]);

    return { data, loading }
}

export { useGetOUWeather }